import Helper from '@ember/component/helper';
import { keyPathToString } from 'cio/utils/objects';

/*
  Creates a liquid tag given a set of nested object keys that can be
  arbitrarily deep.

  {{liquid-tag "customer" attr.label}}

  The trivial implementation would be to join all the attributes with `.`,
  but this doesn't work for attribute names with spaces. Here are some sample
  input-output pairs:

  liquidTag("customer", "name"); // customer.name
  liquidTag("event", "home address"); // event["home address"]
  liquidTag("event", "home address", "street"); // event["home address"].street
  liquidTag("event", "home.address", "street"); // event["home.address"].street
  liquidTag("event", "home/address", "street"); // event["home/address"].street
  liquidTag("event", "home(address)", "street"); // event["home(address)"].street
  liquidTag(["objects", "acmeInc", 0], "name"); // objects.acmeInc[0].name
*/
export function liquidTag([base, ...xs]: [string | (string | number)[], ...(string | number)[]]): string {
  if (Array.isArray(base)) {
    return keyPathToString([...base, ...xs]);
  }

  return keyPathToString([base, ...xs]);
}

export default Helper.helper(liquidTag);
